module.exports = __webpack_public_path__ + "assets/images/project/menu/myanmar-thumb.jpg?v=353166a4";